import { useState, useMemo } from "react";
import type { TopicVocabulary } from "@/lib/dialog-data";

export function useVocabularySearch(vocabulary: TopicVocabulary) {
  const [query, setQuery] = useState("");

  const filtered = useMemo(() => {
    const q = query.toLowerCase().trim();
    if (!q) {
      return vocabulary;
    }

    const words = vocabulary.words.filter((word) => {
      return (
        word.baseForm.toLowerCase().includes(q) ||
        word.translation.toLowerCase().includes(q) ||
        word.forms?.some((f) => f.form.toLowerCase().includes(q) || f.usage?.toLowerCase().includes(q)) ||
        word.examples?.some((e) => e.text.toLowerCase().includes(q) || e.translation.toLowerCase().includes(q))
      );
    });

    const expressions = vocabulary.expressions.filter((expr) => {
      return (
        expr.expression.toLowerCase().includes(q) ||
        expr.translation.toLowerCase().includes(q) ||
        expr.literal?.toLowerCase().includes(q) ||
        expr.examples.some((e) => e.text.toLowerCase().includes(q) || e.translation.toLowerCase().includes(q))
      );
    });

    const topical = vocabulary.topical
      .map((category) => ({
        ...category,
        items: category.items.filter(
          (item) =>
            item.word.toLowerCase().includes(q) ||
            item.translation.toLowerCase().includes(q)
        ),
      }))
      .filter((category) => category.items.length > 0);

    return { words, expressions, topical };
  }, [vocabulary, query]);

  const filteredCount = filtered.words.length + filtered.expressions.length +
    filtered.topical.reduce((sum, cat) => sum + cat.items.length, 0);

  return {
    query,
    setQuery,
    filtered,
    filteredCount,
  };
}
